import { ChevronLeft, ChevronRight } from "lucide-react";
import { getAdjacentServices } from "@/config/serviceSubNavRoutes";

function hrefForServicePath(path, lang) {
  const base = `${process.env.PUBLIC_URL ?? ""}${path}`;
  return lang === "ro" ? base : `${base}?lang=${lang}`;
}

export default function ServiceAdjacentNav({ t, pathname, lang }) {
  const adj = getAdjacentServices(pathname);
  if (!adj) return null;

  const { prev, next, current } = adj;

  return (
    <nav
      aria-label={t.nav.serviceSwitcherAria}
      className="border-b border-[#e2e6ec] bg-[#f7f8fa]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="mx-auto flex w-full max-w-3xl items-center justify-between gap-2 sm:gap-4">
          <a
            href={hrefForServicePath(prev.path, lang)}
            className="inline-flex min-h-[44px] max-w-[42%] shrink-0 items-center justify-center gap-1.5 rounded border border-[#cfd6e6] bg-white px-2 py-2 font-mono text-[10px] uppercase tracking-[0.14em] text-[#0b1220] shadow-sm hover:border-[#0b378c] hover:text-[#0b378c] transition-colors sm:max-w-none sm:gap-2 sm:px-4 sm:text-[11px] sm:tracking-[0.18em]"
            aria-label={`${t.nav.servicePrevAria}: ${t.nav[prev.navKey]}`}
          >
            <ChevronLeft className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
            <span className="truncate text-left leading-tight">{t.nav[prev.navKey]}</span>
          </a>

          <p className="min-w-0 flex-1 truncate text-center font-[Barlow_Condensed] text-base font-bold uppercase tracking-[0.12em] text-[#0b378c] sm:text-lg">
            {t.nav[current.navKey]}
          </p>

          <a
            href={hrefForServicePath(next.path, lang)}
            className="inline-flex min-h-[44px] max-w-[42%] shrink-0 items-center justify-center gap-1.5 rounded border border-[#cfd6e6] bg-white px-2 py-2 font-mono text-[10px] uppercase tracking-[0.14em] text-[#0b1220] shadow-sm hover:border-[#0b378c] hover:text-[#0b378c] transition-colors sm:max-w-none sm:gap-2 sm:px-4 sm:text-[11px] sm:tracking-[0.18em]"
            aria-label={`${t.nav.serviceNextAria}: ${t.nav[next.navKey]}`}
          >
            <span className="truncate text-right leading-tight">{t.nav[next.navKey]}</span>
            <ChevronRight className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
          </a>
        </div>
      </div>
    </nav>
  );
}
